import { Offcanvas } from "react-bootstrap";
import CategoryFormBody from "./CategoryFormBody";
import Filter from "../../Helpers/Filter/Filter";
import FormHeader from "../../Helpers/Form/FormParts/FormHeader";

export function CategoryEditForm({ refetch, id, data, onClose, title }) {
  return (
    <>
      <Filter show={!!id}>
        <Offcanvas.Header>
          <FormHeader title={`Edit category ${title}`} onClose={onClose} />
        </Offcanvas.Header>
        <div className="H-line" />
        <Offcanvas.Body>
          <CategoryFormBody
            refetch={refetch}
            data={data}
            isEditing={true}
            onClose={onClose}
          />
        </Offcanvas.Body>
      </Filter>
    </>
  );
}
